// permissionMixin.js
import store from "@/state/store";


export const permissionMixin = {
  methods: {
    hasPermissionFor(permissionName) {
      return  store.getters['permission/isGuranted'](permissionName)
    }
  }
};
